<template>
  <div id="navbar-main" class="nav-white-class">
    <div class="top-bar text-center" v-if="!hideTopBar">
      <i class="fa-solid fa-gift" style="margin-right: 5px;"></i>
      <span @click="showModal = true" style="text-align: center;" v-html="discountMessage"></span>
    </div>
    <div id="navbar-white">
      <div class="navbar-vue">
        <div class="navbar-top">
          <!-- <div v-if="this.isActiveHortense" class="el-center--flex-column no-deco pointer active-dropdown" @click="showHortense">
            <ul class="list-items">
              <li class="item-title">{{ $t("Hortense.whois") }}</li>
              <li class="no-deco-black-cross">X</li>
              <li>
                <a @click='visitLink(1)' class="no-deco-black">{{ $t("Hortense.whois") }}</a>
              </li>
              <li>
                <a @click='visitLink(2)' class="no-deco-black">{{ $t("Hortense.greenhost") }}</a>
              </li>
              <li>
                <a @click='visitLink(3)' class="no-deco-black">{{ $t("Hortense.greennote") }}</a>
              </li>
              <li>
                <a @click='visitLink(4)' class="no-deco-black">{{ $t("Hortense.evergreen") }}</a>
              </li>
              <li>
                <a @click='visitLink(5)' class="no-deco-black">le Club Hortense</a>
              </li>
            </ul>
          </div> -->
          <div class="el-center--flex-column no-deco pointer" id="dropdown-hortense" @click="visitLink(4)">
            À PROPOS D’HORTENSE
          </div>



          <a href="/" class="logo">
            <img src="../../images/hortense blanc.svg" v-set-alt class="default-logo">
            <img src="../../images/Logo hortense.svg" v-set-alt class="hover-logo">
          </a>


          <div class="navbar-profile el-center--space-around">
            <template>
              <a href="/carte-cadeau" class="gift-btn mr-3">
                <div class="gift-btn__content">
                  <svg
                    class="gift-btn__icon"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-label="Gift"
                  >
                    <path
                      d="M9.67969 5.42578L10.9102 7.5H8.34375C7.53516 7.5 6.9375 6.90234 6.9375 6.09375C6.9375 5.32031 7.53516 4.6875 8.34375 4.6875H8.41406C8.94141 4.6875 9.43359 4.96875 9.67969 5.42578ZM5.25 6.09375C5.25 6.62109 5.35547 7.07812 5.56641 7.5H4.125C3.49219 7.5 3 8.02734 3 8.625V10.875C3 11.5078 3.49219 12 4.125 12H19.875C20.4727 12 21 11.5078 21 10.875V8.625C21 8.02734 20.4727 7.5 19.875 7.5H18.3984C18.6094 7.07812 18.75 6.62109 18.75 6.09375C18.75 4.40625 17.3438 3 15.6562 3H15.5508C14.4258 3 13.4062 3.59766 12.8438 4.58203L12 6.02344L11.1211 4.58203C10.5586 3.59766 9.53906 3 8.41406 3H8.34375C6.62109 3 5.25 4.40625 5.25 6.09375ZM17.0625 6.09375C17.0625 6.90234 16.4297 7.5 15.6562 7.5H13.0547L14.2852 5.42578C14.5664 4.96875 15.0234 4.6875 15.5508 4.6875H15.6562C16.4297 4.6875 17.0625 5.32031 17.0625 6.09375ZM4.125 13.125V19.3125C4.125 20.2617 4.86328 21 5.8125 21H10.875V13.125H4.125ZM13.125 21H18.1875C19.1016 21 19.875 20.2617 19.875 19.3125V13.125H13.125V21Z"
                    />
                  </svg>
                  <span class="raleway-reg-p13">Carte Cadeau</span>
                </div>
              </a>
            </template>
            <div class="navbar-whatsapp" @mouseover="showWhatsAppMessage" @mouseleave="hideWhatsAppMessage">
                <div class="whatsapp-container">
                  <img src="../../images/WHATSAPP.png" v-set-alt class="whatsapp-icon" />
                </div>
                <div v-if="isWhatsAppVisible"  class="whatsapp-message-modal">
                  <p class="message-title">
                    <img
                      v-if="isOpen"
                      src="../../images/circle_14025226.png"
                      alt="phone"
                      class="phone-icon"
                    />
                    <img
                      v-if="!isOpen"
                      src="../../images/circle_14025322.png"
                      alt="phone"
                      class="phone-icon"
                    />
                    Nous sommes disponibles du lundi au vendredi de 9h à 18h par <a href="https://wa.me/33626203846" class="message-link" target="_blank" rel="noopener noreferrer">téléphone</a>.
                  </p>
                  <p class="message-status">
                    <span :class="{ open: isOpen, closed: !isOpen }">
                      {{ isOpen ? "OUVERT ACTUELLEMENT" : "FERMÉ ACTUELLEMENT" }}
                    </span>
                  </p>
                  <p class="message-footer">
                    <img src="../../images/email_542689.png" v-set-alt class="email-icon" />
                    Ou contactez-nous à tout moment via <a href="https://www.hortense.green/pages/contact/" class="message-link">ce formulaire</a>
                  </p>
                </div>
              </div>
            <PageTranslator  class="mr-3 no-deco page-translator" />
            <div class="box-items el-center--space-evenly">
              <div v-if="this.user" class="div-user-dropdown" @click="showMenu = !showMenu">
                <Profildropdown :user="this.user" v-if="showMenu"></Profildropdown>
                <div class="el-center--flex-column no-deco-profil pointer" id="dropdown-profil">
                                    <p class="mb-0 raleway-reg-p15 no-deco no-translate">{{this.userInit(this.user.first_name)}}{{this.userInit(this.user.last_name)}}</p>

                </div>
              </div>
              <a v-else id="show-modal" @click="showModal = true">
                <i class="fa-solid fa-user"></i>
              </a>
              <!-- <hr class="item-separator"> -->
              <span class="item-separator">|</span>
              <a @click.prevent='redirectIfUser'>
                <i class="fa-solid fa-heart"></i>
              </a>
              <img v-if="this.userLevel === 'Green Trotter'" src="../../images/badge-guest.png" class="badge-level" v-set-alt>
              <img v-if="this.userLevel === 'Green Trotter Plus'" src="../../images/badge-member.png" class="badge-level" v-set-alt>
              <img v-if="this.userLevel === 'Green Trotter Premium'" src="../../images/badge-nomad.png" class="badge-level" v-set-alt>
              <img v-if="this.userLevel === 'Green Trotter Infinite'" src="../../images/badge-trotter.png" class="badge-level" v-set-alt>
              <Modalsignup v-if="showModal" @close="setUser"></Modalsignup>
            </div>
          </div>
        </div>
        <div class="navbar-bottom el-center" @mouseover="hideWhatsAppMessage">
          <ul class="el-center--space-evenly mt-2" style="width: 100%; list-style: none;">
            <!-- <li class="item-nav"><a :href="this.origin + '/club-hortense'" class="no-deco">{{ $t("clubs") }}</a></li> -->
            <li class="item-nav"  @mouseover="showSelectionSubmenu = true" @mouseleave="showSelectionSubmenu = false">
              <a :href="this.origin + '/reservation-hotel'" class="no-deco">
                {{ $t("selection") }}
              </a>
              <div class="submenu submenu-selection"
                v-if="showSelectionSubmenu"
              >
                <NavbarSelection />
              </div>
            </li>
            <li class="item-nav" @mouseover="showCollectionsSubmenu = true"  @mouseleave="showCollectionsSubmenu = false">
              <a :href="this.origin + '/collections'" class="no-deco">
                {{ $t("collections") }}
              </a>
              <div class="submenu submenu-collection"
                v-if="showCollectionsSubmenu"
              >
                <NavbarCollections :collections="collections" />
              </div>
            </li>
  <!--          <li class="item-nav"><a :href="this.origin + '/experiences-bien-etre'" class="no-deco">{{ $t("yogacation") }}</a></li>-->
  <!--          <li class="item-nav"><a :href="this.origin + '/offres-exclusives'" class="no-deco">{{ $t("exclusive") }}</a></li>-->
            <li class="item-nav" @mouseover="showDestinationsSubmenu = true" @mouseleave="showDestinationsSubmenu = false">
              <a :href="this.origin + '/destination'" class="no-deco">
                {{ $t("destinations") }}
              </a>

              <div class="submenu submenu-destination"
                v-if="showDestinationsSubmenu && destinations"
              >
                <NavbarDestinations :destinations="destinations" />
              </div>
            </li>
            <li class="item-nav">
              <a :href="this.origin + '/offres-exclusives-hortense'" class="no-deco">
                Nos offres exclusives
              </a>
            </li>
            <li class="item-nav"
                @mouseover="showBusinessSubmenu = true"
                @mouseleave="showBusinessSubmenu = false">
              <a :href="this.origin + '/seminaire-eco-responsable'" class="no-deco">
                Hortense For Business
              </a>
              <div class="submenu submenu-business"
                  v-if="showBusinessSubmenu">
                <NavbarBusiness />
              </div>
            </li>
            <!-- <li class="item-nav" @mouseover="showGiftBoxSubmenu = true" @mouseleave="showGiftBoxSubmenu = false">
              <a :href="this.origin + '/coffrets-cadeaux'" class="no-deco">
                NOS COFFRETS CADEAUX
              </a>
              <div class="submenu submenu-gift-box"
                v-if="showGiftBoxSubmenu"
              >
                <NavbarGiftBox />
              </div>
            </li> -->
            <!-- <li class="item-nav"><a :href="this.origin + '/inspirations-voyage-ecoresponsable'" class="no-deco">Inspirations</a></li> -->
  <!--          <li class="item-nav"><a :href="'/experiences'" class="no-deco">{{ $t("experiences") }}</a></li>-->
            <!-- <li class="item-nav"><a :href="this.origin + '/galerie-hotel-ecoresponsable'" class="no-deco">Galerie</a></li> -->
            <li class="item-nav"><a href="https://www.blog.hortense.green/" class="no-deco">{{ $t("newspaper") }}</a></li>
          </ul>
        </div>
    <ModalLoginAdmin v-if='showAdminModal' @closeAdmin='closeModalAdmin'></ModalLoginAdmin>
      </div>
    </div>
  </div>
</template>

<script>
  import fetcher from 'packs/shared/api.js';
  import Modalsignup from '../modals/Modalsignup.vue';
  import Profildropdown from 'components/menus/Profildropdown.vue';
  import ModalLoginAdmin from 'components/modals/ModalLoginAdmin';
  import NavbarDestinations from 'components/shared/NavbarDestinations.vue';
  import NavbarCollections from 'components/shared/NavbarCollections.vue';
  import NavbarSelection from 'components/shared/NavbarSelection.vue';
  import NavbarGiftBox from 'components/shared/NavbarGiftBox.vue';
  import PageTranslator from 'components/shared/PageTranslator.vue';

  export default {
    name: "navbar-white",
    components: { Modalsignup, Profildropdown, ModalLoginAdmin, NavbarDestinations, NavbarCollections, NavbarSelection, NavbarGiftBox, PageTranslator },
    props: ["user", "destinations"],
    data() {
      return {
        collections: [],
        showMenu: false,
        isActiveHortense: false,
        isActiveCurrencies: false,
        showModal: false,
        showAdminModal: false,
        selectedCurrency: "FR/EUR",
        currencies: [{"currency": "FR/EUR", "lang": "fr"}, {"currency": "UK/GBP", "lang": "en"}, {'currency': "US/USD", "lang": "en"}],
        locale: 'fr',
        origin: window.location.origin,
        userLevel: null,
        userMount: '',
        isWhatsAppVisible: false,
        whatsappMessage: "",
        isOpen: false,
        discountMessage: "-10% sur votre 1er séjour",
        showDestinationsSubmenu: false,
        showCollectionsSubmenu: false,
        showSelectionSubmenu: false,
        showGiftBoxSubmenu: false,
        showBusinessSubmenu: false,
        destinations: []
      }
    },
    watch: {
      locale(val) {
        this._i18n.locale = val
      }
    },
    mounted() {
      Promise.all([
        this.fetchCollections(),
        this.fetchDestinations()
      ]).then(() => {
        // Set default promotion message first
        this.setDefaultPromotionMessage();
        // Then check for loyalty status
        return this.setUserLevel();
      }).then(() => {
        // Finally check for lodging-specific banner message
        return this.setDiscountMessage();
      }).catch(error => {
        console.error('Error during navbar initialization:', error);
      });
      this.$root.$on('openModal', _ => {
        this.showModal = true;
      });

      if (window.location.search === '?signin' && !this.user) {
        this.showModal = true;
      }

      if (window.location.search === '?admin_login' && !this.user) {
        this.showAdminModal = true;
      }
    },
    methods: {
      async fetchCollections() {
        try {
          const response = await fetch('/collections.json');
          if (response.ok) {
            this.collections = await response.json();
          }
        } catch (error) {
          console.error('Error fetching collections:', error);
        }
      },
      async setDiscountMessage() {
        const pathParts = window.location.pathname.split('/');
        console.log('pathParts', pathParts)

        if (pathParts[1] === 'reservation-hotel' && pathParts[2]) {
          console.log('pathParts[2]', pathParts[2])
          const slug = pathParts[2];
          try {
            const response = await fetcher.get(`/lodging/${slug}/banner_message`);
            const msg = response?.data?.message;
            if (msg && msg.trim() !== '') {
              this.discountMessage = msg;
              return;
            }
          } catch (e) {
            console.error("Error fetching banner message:", e.message);
            // Continue with default message
          }
        }
      },
      setDefaultPromotionMessage() {
        this.discountMessage = '<span>Rejoignez le <a @click="showModal = true" style="text-decoration: underline; cursor: pointer; color: white;">Club Hortense</a> et profitez de -10% sur votre 1er séjour</span>';
      },
      getLoyaltyMessage() {
        const messages = {
          'Membre': 'Cumulez des points fidélité et profitez de privilèges exclusifs lors de votre prochain séjour.',
          'Green Trotter': 'Grâce à votre statut Green Trotter, vous bénéficiez de 1 privilège exclusif lors de votre prochain séjour.',
          'Green Trotter Plus': 'Grâce à votre statut Green Trotter Plus, vous bénéficiez de 2 privilèges exclusifs lors de votre prochain séjour.',
          'Green Trotter Premium': 'Grâce à votre statut Green Trotter Premium, vous bénéficiez de 3 privilèges exclusifs lors de votre prochain séjour.',
          'Green Trotter Infinite': 'Grâce à votre statut Green Trotter Infinite, vous bénéficiez de 4 privilèges exclusifs lors de votre prochain séjour.'
        };
        return messages[this.userLevel] || '<span>Rejoignez le <a @click="showModal = true" style="text-decoration: underline; cursor: pointer; color: white;">Club Hortense</a> et profitez de -10% sur votre 1er séjour</span>';
      },
      showWhatsAppMessage() {
        if (!this.isWhatsAppVisible) {
          this.isOpen = this.checkOpenHours();
          this.isWhatsAppVisible = true;
        }
      },
      hideWhatsAppMessage() {
        this.isWhatsAppVisible = false;
      },
      checkOpenHours() {
        const now = new Date();
        const currentHour = now.getHours();
        const currentDay = now.getDay();
        return currentDay >= 1 && currentDay <= 5 && currentHour >= 9 && currentHour < 18;
      },
      visitLink(n){
          switch (n) {
          case 1:
            window.location.href = '/qui-est-hortense-voyage-ecoresponsable/'
            break;
          case 2:
            window.location.href = '/label-ecoresponsable-green-host/'
            break;
          case 3:
            window.location.href = '/green-note-engagement-environnemental/'
            break;
          case 4:
            window.location.href = '/qui-est-hortense'
            break;
          case 5:
            window.location.href = '/programme-fidélité-hortensia/'
            break;
        }
      },
      closeModalAdmin() {
        window.location.search = '';
        this.showAdminModal = false;
      },
      userInit(string){
        let names = string.split(','),
          initials = names[0].substring(0, 1).toUpperCase();
        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
      },
      setUser(user){
        this.user = user;
        this.showModal = false;
      },
      async setUserLevel(){
        try {
          if (this.user) {
            const res = await fetcher.get('/dashboard/'+this.user.slug)
            this.userMount = res.data
            if (res.data && res.data.reservations && res.data.reservations.length > 0) {
              // Filter reservations to only include confirmed ones
              const confirmedReservations = res.data.reservations.filter(
                reservation => reservation.confirm === true && reservation.cancel !== true
              );
              if (confirmedReservations.length > 0 && res.data.loyalty_status && res.data.is_code_used) {
                this.userLevel = res.data.loyalty_status;
                this.discountMessage = this.getLoyaltyMessage();
              }
            }
          }
        } catch(e) {
          console.error(e.message)
        }
      },
      showHortense() {
        this.isActiveHortense = !this.isActiveHortense;
      },
      showCurrencies(e) {
        const el = e.currentTarget.lastElementChild;
        el.style.transform = el.style.transform ? '' : 'rotateZ(180deg)';
        this.isActiveCurrencies = !this.isActiveCurrencies;
      },
      currenciesLeft() {
        return this.currencies.filter(x => {return x.currency !== this.selectedCurrency })
      },
      selectCurrency(e) {
        this._i18n.locale = e.currentTarget.value;
        this.selectedCurrency = e.currentTarget.innerText;
        this.isActiveCurrencies = false;
        const el = document.querySelector('.arrow');
        el.style.transform = el.style.transform ? '' : 'rotateZ(180deg)';
      },
      redirectIfUser() {
        if (this.user) {
          Turbolinks.visit('/wishlists');
        }
        this.showModal = true;
      },
      fetchDestinations() {
        const response = fetcher.get('/destination', {
          params: { countries: ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE'] }
        }).then(response => {
          this.destinations = response.data;
        }).catch(error => {
          console.error('Error fetching destinations:', error);
        });
      },
    },
    computed: {
      hideTopBar() {
        return window.location.pathname.includes('/seminaire-eco-responsable');
      }
  },
  }
</script>

<style lang="scss" scoped>

.gift-btn {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 6px;
  background: transparent;
  color: white;
  text-decoration: none;
  border: 1px solid white;
  transition: all 0.2s ease;
}

.gift-btn:hover {
  background: #f5f5f5;
  color: black;
  border: 1px solid black;
}

.nav-trans-desk .gift-btn {
  background: transparent;
  color: white;
  border-color: white;
}

.nav-trans-desk .gift-btn:hover {
  color: #c5e3ff;
  border-color: #c5e3ff;
}

#navbar-white:hover .navbar-vue .navbar-top .navbar-profile .gift-btn {
  border: solid 1px black;
  color: black;
}

.gift-btn__content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gift-btn__icon {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.modal-mask {
  z-index: 1;
}
.modal-wrapper {
  z-index: 100000;
}

  #show-modal {
    cursor: pointer;
  }
  #dropdown-hortense {
    width: 257px;
    display: flex;
    align-items: flex-start;
    font-weight: 600;
    padding-left: 3rem;
  }

  #dropdown-profil{
   width: 30px;
    height: 30px;
    p{
      color:white;
    }
  }


  .active-dropdown {
    width: 257px;
    height: 185px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    position: relative;
    left: -43px;
    top: 6px;
    z-index: 2;
    margin-left: 3rem;
    .list-items{
      list-style: none;
      padding: 2px;
      li{
        padding-bottom: 0.4rem;
      }
    }
    .item-title {
      font: normal normal 13px/36px $Raleway;
      letter-spacing: 0px;
      color: white;
      text-transform: uppercase;
      height: 30px;
    }
  }

  .pointer {
    cursor: pointer;
  }

  .no-deco {
    color: white;
    font-family: $Raleway;
    font-weight: 400;
    font-size: 13px;
    text-transform: uppercase;

    &:hover {
      text-decoration: none;
      color: #000000;
    }
  }
  .no-deco-black {
    color: white;
    font-family: $Raleway;
    font-weight: 400;
    font-size: 13px;
    text-transform: uppercase;
    color: black;
    &:hover {
      text-decoration: none;
      color: #000000;
      border-bottom: 5px solid #3B6152;
    }
  }

  .no-deco-black-cross {
    display: flex;
    justify-content: flex-end;
    color: white;
    font-family: $Raleway;
    font-weight: 400;
    font-size: 15px;
    text-transform: uppercase;
    color: black;
    &:hover {
      text-decoration: none;
      font-weight: 600;
    }
  }

  .profil-photo {
    width: 30px;
    height: 30px;
    border: 1px solid #A5D3AE;
    border-radius: 50%;
    background: url(https://images.unsplash.com/photo-1608504408764-f7a95454afd5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=647&q=80);
    background-position: center;
    background-size: cover;
  }

  .item-nav {
    text-align: center;
    font: normal normal 13px/15px $Raleway;
    letter-spacing: 0px;
    color: #000000;
    text-transform: uppercase;
  }

  .navbar-bottom {
    width: 1043px;
    height: 15px;
  }

  .currencies-block {
    cursor: pointer;
  }

  .currencies {
    width: 57px;
    height: 15px;
    text-align: right;
    font: normal normal 13px/15px $Raleway;
    letter-spacing: 0px;
    color: #000000;
    text-transform: uppercase;
    opacity: 1;
    &-block {
      width: 72px;
      height: 15px;
    }
  }

  .arrow {
    display : inline-block;
    height : 0;
    width : 0;
    border-top : 9px solid black;
    border-right : 5px solid transparent;
    border-left : 5px solid transparent;
  }

  .el-center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;

    &--flex-column {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    &--space-around {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }

    &--space-evenly {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
    &--space-between {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  #navbar-white {
    height: 154px;
    width: 100%;
    background: transparent;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 2.6%;
    transition: background-color 0.3s;
    z-index: 100;
    // backdrop-filter:brightness(107%);

    .logo{
      img{
        width: 280px;
      }
    }

    .navbar-vue {
      width: 1280px;
      height: 106px;
      max-height: 106px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .navbar-top {
        display: flex;
        justify-content: space-between;
        width: 100%;
        max-height: 52.54px;
        .navbar-profile {
          width: fit-content;
          .box-items {
            width: 87px;
            height: 40px;
            border: solid 1px white;
            border-radius: 64px;
            i{
              color:white;
            }
            .item-separator{
              color: white;
              width: 10px;
              margin: 0;
            }
            .div-user-dropdown{
              width:2rem;
            }
          }
        }
      }
    }
  }

  #navbar-white:hover {
    background-color: white;
  }

  #navbar-white:hover .no-deco {
    color: #000000;
    text-decoration: none;
  }

  .logo .hover-logo {
    display: none;
  }

  #navbar-white:hover .navbar-vue .navbar-top .navbar-profile .box-items {
    width: 87px;
    height: 40px;
    border: solid 1px black;
    border-radius: 64px;
    i{
      color:black;
    }
    .item-separator{
      color: black;
      width: 10px;
      margin: 0;
    }
  }

  #navbar-white:hover .default-logo {
    display: none !important;
  }

  #navbar-white:hover .hover-logo {
    display: block !important;
  }

  #navbar-white:hover .fa-user,
  #navbar-white:hover .fa-heart {
    color: black !important;
  }

  #navbar-white:hover navbar-top {
    .navbar-profile {
      .box-items {
        border: solid 1px black !important;

        i {
          color: black !important;
        }

        .item-separator {
          color: black !important;
        }
      }
    }
  }

    .badge-level{
    width: 20px;
    right: 152px;
  }

  .dropdown {
    width: 40px;
    &__header {
      cursor: pointer;
      line-height: 50px;
      // padding-left: 10px;
      // padding-right: 50px;
      position: relative;
      text-overflow: ellipsis;
      margin-top: 29px;
      margin-left: 1rem;
      margin-top: 29px;
      margin-left: 1rem;
      margin-right: 0px;
      &.is-active {
        + .dropdown__content {
          width: 257px;
          height: 185px;
          background: #FFFFFF 0% 0% no-repeat padding-box;
          position: relative;
          left: -95px;
          top: 108px;
          z-index: 2;
          opacity: 1;
          visibility: visible;
          ul{
            height: inherit;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            list-style: none !important;
          }
        }
      }
    }
    &__content {
      height: 0;
      opacity: 0;
      overflow: hidden;
      padding: 15px 10px;
      transition: opacity .3s;
      visibility: hidden;
    }
  }


  .navbar-whatsapp {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.whatsapp-container {
  display: flex;
  align-items: center;
  gap: 3px;
}

.whatsapp-message-modal {
  position: absolute;
  top: 85px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px;
  width: 50vw;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  text-align: left;
  z-index: 100;
  right: 14px;
  overflow-wrap: break-word;
}

.message-title {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #333;
  font: normal normal medium 18px/29px Merriweather;
}

.phone-icon {
  width: 16px;
  height: 16px;
}

.message-status {
  margin: 5px 0;
  font: normal normal bold 18px/29px  Merriweather;
}

.message-status .open {
  color: #3b6152;
}

.message-status .closed {
  color: #D56A70;
}

.message-footer {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #555;
  font: normal normal medium 18px/29px Merriweather;
}

.email-icon {
  width: 16px;
  height: 16px;
}

.message-link {
  color: #000000;
  text-decoration: underline;
  cursor: pointer;
}

.message-link:hover {
  text-decoration: none;
}
.whatsapp-icon {
  width: 115px;
  height: 115px;
  margin-right: 8px;
}
@media (max-width: 600px) {
  .whatsapp-message-modal {
    width: 90%; 
    left: 5%; 
    padding: 15px;
  }

  .message-title {
    font-size: 16px;
  }

  .message-status {
    font-size: 14px;
  }

  .message-footer {
    font-size: 14px;
  }
}
#navbar-main {
    display: flex;
    flex-direction: column;
    .top-bar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 40px;
      font-size: 15px;
      color: white;
      background: #1c1c1c;
      position: fixed;
      top: 0;
      z-index: 1000;
    }
}

.submenu {
  position: absolute;
  top: 100%;
  left: 2%;
  right: 1%;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0px 20px 20px 0px #00000033;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: -32px;
}

.submenu-destination {
  width: 95%;
}

.submenu-collection {
  width: 70%;

  @media screen and (max-width: 1450px) {
    width: 80%;
  }

  @media screen and (max-width: 1270px) {
    width: 90%;
  }
  @media screen and (max-width: 1150px) {
    width: 100%;
  }
}

.submenu-gift-box {
  width: 40%;
  left: unset;
  right: 4% !important;
}

.submenu-selection {
  width: 35%;
}

@media screen and (max-width: 1340px) {
  .submenu-selection {
    width: 42%;
  } 
}

@media screen and (max-width: 1540px) {
  .submenu-selection {
    width: 40%;
  } 
}

@media screen and (max-width: 1170px) {
  .submenu-selection {
    width: 47%;
  } 
}
@media screen and (max-width: 1600px) {
  .submenu-destination {
    width: 95%;
  } 
}
.submenu-business {
  width: 40%;
  left: 40%;
}
</style>
